<!-- Make the field read-only to non-admins -->
<div *ngIf="!canEdit">{{jobNumber}}</div>
<form [formGroup]="form">
        <mat-form-field *ngIf="canEdit">
            <mat-label *ngIf="showLabel">Job Number</mat-label>
            <input matInput
                   type="text"
                   formControlName="jobNumberCtrl"
                   id="jobNumber"
                   maxlength="15"
                   minlength="5"
                   (blur)="onTouched()"
                   (keyup)="enterPress($event)"
                   (focusout)="enterPress($event)">
            <mat-error *ngIf="form.get(jobNumberCtrl).hasError('maxlength')">
                Must be less than 15 characters.
            </mat-error>
            <mat-error *ngIf="form.get(jobNumberCtrl).hasError('max')">
                Must be less max integer number.
            </mat-error>
            <mat-error *ngIf="form.get(jobNumberCtrl).hasError('minlength')">
                Must be 5 characters or more.
            </mat-error>
            <mat-error *ngIf="form.get(jobNumberCtrl).hasError('pattern')">
                Must be a number.
            </mat-error>
            <mat-error *ngIf="form.get(jobNumberCtrl).hasError('required')">
                Job number is required.
            </mat-error>
        </mat-form-field>
</form>
